import React, { useCallback, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';

import { userTextChat } from '../../friends/components';

import { Chat, ChatMessage } from '@/components/GenericsTournaments';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useToast from '@/hooks/useToast';
import useTourney from '@/hooks/useTourney';
import {
  requestGetChatMessages,
  requestPostChatMessages,
} from '@/services/minileagues';
import { RequestSaveChatMessages } from '@/types/minileagues';

type Props = {
  users: userTextChat[];
  isTap?: boolean;
};

export const ChatBox: React.FC<Props> = ({ users: propUsers }) => {
  const [users, setUsers] = useState<userTextChat[]>([]);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const { isDesktop } = useIsDesktop();

  const toast = useToast();
  const { tourneyData } = useTourney();

  const {
    data: chatData,
    isFetching,
    isLoading,
  } = useQuery(
    'responseGetChatMessages',
    async () =>
      await requestGetChatMessages({
        idMiniLiga: tourneyData.id,
        cantPorPagina: 1000,
      }),
    {
      refetchOnWindowFocus: false,
      enabled: tourneyData.id !== 0 && isDesktop,
    }
  );

  useEffect(() => {
    if (
      chatData?.estado &&
      !isLoading &&
      !isFetching &&
      chatData.page?.objectList
    ) {
      setMessages(
        chatData.page?.objectList.map((element) => ({
          name: element.user || '',
          msg: element.descripcion || '',
          time: element.fechaMostar || '',
          profilePic: element.fotoPerfil,
        }))
      );

      const usersFromMessages: userTextChat[] = chatData.page?.objectList.map(
        (post) => ({
          id: String(post.idUsuario),
          display: String(post.user),
        })
      );

      // Combina usuarios del chat y de las props
      const combinedUsers = [...propUsers, ...usersFromMessages].filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.display === value.display)
      );

      setUsers(combinedUsers);
    }
  }, [propUsers, chatData, isLoading, isFetching]);

  const { mutateAsync: postChatMessage } = useMutation(
    async (data: RequestSaveChatMessages) =>
      await requestPostChatMessages(data),
    {
      onSuccess: (data) => {
        if (!data.estado) {
          toast.show(data.mensaje);
        }
      },
      onError: (err) => {
        const error = err as Error;
        toast.showError(error);
      },
    }
  );

  const handleSubmit = useCallback(
    (msg: string) => {
      // eslint-disable-next-line no-console
      console.log(`Envio de mensaje Miniligas`);
      postChatMessage({
        idMiniLiga: tourneyData.id,
        mensaje: msg,
      });
    },
    [postChatMessage, tourneyData.id]
  );

  return (
    // CHAT GENERICO
    <Chat
      handleSubmit={handleSubmit}
      isLoading={isFetching || isLoading}
      messages={messages}
      users={users}
    />
  );
};
